export const CREATE_PRICING_METHOD_MUTATION = `
  mutation CreatePricingMethod($object: pricing_methods_insert_input!) {
    insert_pricing_methods_one(object: $object) {
      id
      name
      description
      status
      company_id
      company {
        id
        name
      }
      created_at
      updated_at
    }
  }
`;

export const UPDATE_PRICING_METHOD_MUTATION = `
  mutation UpdatePricingMethod($id: Int!, $set: pricing_methods_set_input!) {
    update_pricing_methods_by_pk(pk_columns: { id: $id }, _set: $set) {
      id
      name
      description
      status
      company_id
      company {
        id
        name
      }
      created_at
      updated_at
    }
  }
`;

export const DELETE_PRICING_METHOD_MUTATION = `
  mutation DeletePricingMethod($id: Int!) {
    delete_pricing_methods_by_pk(id: $id) {
      id
    }
  }
`; 